import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/root-reducer';
import { ErrorInfo, RenderingState } from 'redux/types';

export const initialState: RenderingState = {
  isLoading: false,
  success: false,
  error: {
    message: '',
    statusCode: null,
  },
};

const showApplicationFormSlice = createSlice({
  name: 'SHOW_APPLICATION_FORM',
  initialState,
  reducers: {
    loading: (state) => {
      state.isLoading = true;
    },
    success: (state) => {
      state.isLoading = false;
      state.success = true;
      state.error.message = '';
      state.error.statusCode = null;
    },
    failure: (state, action: PayloadAction<ErrorInfo>) => {
      state.isLoading = false;
      state.error.message = action.payload.message;
      state.error.statusCode = action.payload.statusCode;
    },
  },
});

// REDECER
export default showApplicationFormSlice.reducer;

// ACTIONS
export const { loading, success, failure } = showApplicationFormSlice.actions;

// SELECTORS
export const selectIsLoading = (state: RootState) =>
  state.ui.job.create.applicationForm.show.isLoading;
export const selectSuccess = (state: RootState) =>
  state.ui.job.create.applicationForm.show.success;
export const selectError = (state: RootState) =>
  state.ui.job.create.applicationForm.show.error;
